/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Tax_LabelInputs */

const en_company_tax_label = /** @type {(inputs: Company_Tax_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax no. (PIB)`)
};

/**
* | output |
* | --- |
* | "Tax no. (PIB)" |
*
* @param {Company_Tax_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const company_tax_label = /** @type {((inputs?: Company_Tax_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Tax_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_company_tax_label(inputs)
});